
import React, {useState} from "react";
import { Button, Form } from "react-bootstrap";
import doller from "../../../assets/images/game/doller.svg";
import refresh from "../../../assets/images/game/refresh.svg"
import rollimg from "../../../assets/images/game/roll.svg"
import cross from "../../../assets/images/game/cross.svg"
import percent from "../../../assets/images/game/percent.svg"
import InputRange from 'react-input-range';
import "react-input-range/lib/css/index.css"

const AutomatedGame = () => {

    const [range, setRange] =  useState(50);
    const [roll, setRoll] =  useState(false);

    const handleRoll = () => {
        setRoll(!roll)
        setRange(100-range)
    }

    return(
        <div className="automated-game">

            <Form>
            <div className="automated-grid">

                <div className="automated-option">
            <div className="bet-box">
            <Form.Group className="half-w">
                <Form.Label>Bet Amount</Form.Label>
                <div className="bet-input pdd-200">
                    <img src={doller} alt="" />
                    <Form.Control type="number" placeholder="58.52" />
                    <div className="bet-input-btn">
                        <Button>1/2</Button>           
                        <Button>2x</Button>           
                        <Button>Max</Button>
                    </div>
                </div>
            </Form.Group>

            <Form.Group className="half-w">
                <Form.Label>Payout On Win</Form.Label>
                <div className="bet-input">
                    <img src={doller} alt="" />
                    <Form.Control type="number" placeholder="58.52" />
                </div>
            </Form.Group>

            </div>

            <div className="payout-box">

                        <Form.Group>
                            <Form.Label>Roll {roll ? <span>Under</span> : <span>Over</span>}</Form.Label>
                            <div className={`bet-input roll-input ${roll ? `apply` : ``}`}>
                                <span onClick={handleRoll} className="roll-under" role="presentation"><img src={rollimg} alt="" /></span>
                                <img src={refresh} alt="" />
                                <Form.Control type="number" placeholder="58.52" />
                            </div>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Multiplier</Form.Label>
                            <div className="bet-input">
                                <img src={cross} alt="" />
                                <Form.Control type="number" placeholder="58.52" />
                            </div>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Win Chance</Form.Label>
                            <div className="bet-input">
                                <img src={percent} alt="" />
                                <Form.Control type="number" placeholder="58.52" />
                            </div>
                        </Form.Group>

                </div>

                </div>




                <div className="automated-extra-options">


                        <Form.Group className="half-w">
                            <Form.Label>On Win</Form.Label>
                            <div className="bet-input">
                            <Form.Control type="number" placeholder="2" />
                            </div>
                            <div className="bet-input-radio">
                            <Form.Check id="bet1" name="bet" type="radio" label="Multiply by" />
                            <Form.Check id="bet2" name="bet" type="radio" label="Return to base bet" />
                            </div>
                        </Form.Group>

                        <Form.Group  className="half-w">
                            <Form.Label>On Lose</Form.Label>
                            <div className="bet-input">
                            <Form.Control type="number" placeholder="2" />
                            </div>
                            <div className="bet-input-radio">
                            <Form.Check id="bet3" name="bet" type="radio" label="Multiply by" />
                            <Form.Check id="bet4" name="bet" type="radio" label="Return to base bet" />
                            </div>
                        </Form.Group>


                        <Form.Group>
                            <Form.Label>Max Bet</Form.Label>
                            <div className="bet-input">
                                <img src={doller} alt="" />
                                <Form.Control type="number" placeholder="956985.01" />
                            </div>
                        </Form.Group>

                        
                        <Form.Group>
                            <Form.Label>Speed</Form.Label>
                            <div className="bet-input">
                            <div className="custom-slider range">
                                <Form.Control type="range"/>
                                </div>
                            </div>
                        </Form.Group>



                        <Form.Group>
                            <Form.Label>Roll Limit</Form.Label>
                            <div className="bet-input">
                            <img src={refresh} alt="" />
                                <Form.Control type="number" placeholder="2" />
                            </div>
                        </Form.Group>

                </div>

                </div>


                <div className="roll-dice">
                    <Button>ROLL DICE</Button>
                </div>

                <div className={`roll-slider dice-slider ${roll ? `flips` : ``}`}>
                    <InputRange
                    maxValue={100}
                    minValue={0}
                    value={range}
                    onChange={value => setRange(value)} />
                </div>


            </Form>


        </div>


);
};

export default AutomatedGame;